import ModelApiService from "../utils/modelApiService";

class PersonApiService extends ModelApiService {
  constructor() {
    super("/persons/", "personne");
  }
}

export default PersonApiService;